import { type Bucket } from 'investments/common/entities'
import { isCollateralBucket } from 'investments/common/utils'

import { useFetchCollateralLimits } from './use-fetch-collateral-limits'

export function useWithdrawableBucketList({
  accountId,
  bucketList,
  enabled
}: {
  accountId: string
  bucketList: Bucket[]
  enabled: boolean
}) {
  const bucketsWithBalance = bucketList.filter(bucket => bucket.balance.netAmount > 0)
  const hasCollateral = bucketsWithBalance.some(isCollateralBucket)

  const { collateralLimits } = useFetchCollateralLimits({
    accountId,
    options: { enabled: enabled && hasCollateral }
  })

  const isCollateralWithdrawAvailable = collateralLimits?.withdrawAvailability.isAvailability === true
  const withdrawableBucketList = bucketsWithBalance.filter(
    bucket => !isCollateralBucket(bucket) || isCollateralWithdrawAvailable
  )

  return { withdrawableBucketList }
}
